export default {
  en: {
    translation: {
      general: {
        daroog: 'Daroog',
        tabadol: 'Tabadol',
        lang: 'Language',
        yes: 'Yes',
        no: 'No',
        confirm: 'Confirm',
        search: 'Search',
        dashboard: 'Dashboard',
        theme: 'Theme',
        colors: 'Colors',
        base: 'Base',
        notification: 'Notification',
        notifications: 'Notifications',
        home: 'Home',
        description: 'Description',
        active: 'Active',
        type: 'Type',
        save: 'Save',
        cancel: 'Cancel',
      },
      action: {
        insert: 'Insert',
        delete: 'Delete',
      },
      error: {
        'you-are-lost': "Oops! You're lost.",
        'page-not-found': 'The page you are looking for was not found.',
        'error-500-line': 'Houston, we have a problem!',
        'error-500-sub':
          'The page you are looking for is temporarily unavailable.',
        'fill-requireds': 'Please fill the required values.',
        'loading-data': 'Something happend in loading data from server.',
        save: "There's a problem in saving data.",
        remove: 'Error happend in removing data.',
      },
      login: {
        login: 'Login',
        exit: 'Exit',
        signOut: 'Sign out',
        'login-sub': 'Sign In to your account',
        'forgot-password': 'Forgot password?',
        'sign-up': 'Sign Up',
        'register-now': 'Register now!',
        register: 'Register',
        'register-sub': 'Create your account',
        'create-account': 'Create Account',
        username: 'Username',
        password: 'Password',
        successful: 'Login was successful. Welcome!',
        failed:
          "Login wasn't successful. Please check your username and password.",
      },
      user: {
        role: 'User Role',
        user: 'User',
        users: 'Users',
        profile: 'Profile',
        'create-new-role': 'Create New Role',
        'edit-role': 'Edit Role',
        'cancel-edit-eole': 'Cancel editing role',
      },
      drug: {
        drug: 'Drug',
        category: 'Category',
        categoryID: 'Category ID',
        name: 'Drug Name',
        genericName: 'Generic Name',
        companyName: 'Company Name',
        barcode: 'Barcode',
        enName: 'English Name',
        create: 'Create Drug',
      },
    },
  },
};
